
angular.module('bmsApp.directives').factory('ScheduleSvc', function (
		CRUDSvc,
		SCHEDULE_API) {

	return {
		getSchedule: function () {
			return CRUDSvc.get(SCHEDULE_API.GET_SCHEDULE);
		},
		dismissSchedule: function (params) {
			return CRUDSvc.post(SCHEDULE_API.DISMISS_SCHEDULE, params);
		}
	};

}).constant('SCHEDULE_API', {
	GET_SCHEDULE: 'api/schedule/get-schedule',
	DISMISS_SCHEDULE: 'api/schedule/dismiss-schedule'
});
